<template>
  <div class="follow-order">
    <FilterPanel @apply="page = 1; getDataPackage(20, 0)">
<div class="filter-field">
<label for="storemng-list-f50">استان</label>
          <select id="storemng-list-f50" @change="getCityOnChange" v-model="pickProvince" class="form-select">
<option value="">همه</option>
            <option v-for="province in provinceLists" :value="province.id" :key="province.id">
              {{ province.name }}
            </option>
          </select>
</div>
<div class="filter-field">
<label for="storemng-list-f51">شهر</label>
          <select id="storemng-list-f51" v-model="pickCity" class="form-select">
<option value="">همه</option>
            <option v-for="city in cityLists" :value="city.city.id" :key="city.city.id">
              {{ city.city.name }}
            </option>
          </select>
</div>
<div class="filter-field">
<label for="storemng-list-f52">تعداد ویزیت</label>
          <input id="storemng-list-f52" class="inputs" v-model="visitCount" />
</div>
<div class="filter-field">
<label for="storemng-list-f53">کد مشتری</label>
          <input id="storemng-list-f53" class="inputs" v-model="storeCode" />
</div>
<template #actions>
<button type="submit" class="accept">اعمال فیلتر</button>
<button type="button" class="remove-filtes" @click="removeFilter">پاک کردن فیلترها</button>
</template>
</FilterPanel>
    <div class="box list-box">
      <div>
        <Tableview
          :hover="true"
          :bordered="true"
          :showNoContent="showContnetFunc"
          :showNoData="showDataFunc"
         :recordCount="totalDataCount" :page="page">
<template #controls>
<label class="ordering-title">مرتب سازی بر اساس </label>
					<b-form-select
						v-model="selected"
						:options="options"
						class="ordering"
						value-field="item"
						text-field="name"
						@change="page = 1; getDataPackage(20, 0)"
					></b-form-select>
</template>
<template #footer>
<pagination
          v-model="page"
          :per-page="20"
          :records="totalDataCount"
          @paginate="myCallback"
        />
</template>
          <template #TableTitle>
            <tr>
              <th>ردیف</th>
              <th>شهر</th>
              <th>منطقه</th>
              <th>محله</th>
              <th>نام مشتری</th>
              <th>ادرس مشتری</th>
              <th>نوع مشتری</th>
              <th>کد مشتری</th>
              <th>تعداد ویزیت</th>
              <th>جزئیات فروشگاه</th>
            </tr>
          </template>

          <template #TableBody>
            <tr v-for="(item, index) in dataPackage" :key="item.id">
              <td class="persian-number">
                {{ 20 * (page - 1) + 1 + index }}
              </td>
              <td>{{ (item.city && item.city.name) || '—' }}</td>
              <td>
                <span v-if="item.district !== null">{{ item.district.verbose_name }}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="item.region !== null">{{ item.region.verbose_name }}</span>
                <span v-else>-</span>
              </td>
              <td>{{ item.name }}</td>
              <td class="persian-number">{{ item.address }}</td>
              <td>{{ (item.category && item.category.verbose_name) || '—' }}</td>
              <td class="persian-number">{{ item.code }}</td>
              <td class="persian-number">{{ item.visit_count }}</td>

              <td>
                <RowActions :items="[{ label: 'مشاهده جزئیات', icon: 'view', action: () => detail(item.id) }]" />
              </td>
            </tr>
          </template>
        </Tableview>
      </div>
    </div>
  </div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';
import Pagination from '@/components/ListPagination/index.vue';

import RowActions from '@/components/RowActions/index.vue';
import FilterPanel from '@/components/FilterPanel/index.vue';
export default {
  components: { FilterPanel, RowActions,
    Tableview,
    Pagination,
  },
  data() {
    return {
      dataPackage: 0,
      cityLists: [],
      promoterLists: [],
      provinceLists: [],
      pickProvince: '',
      pickCity: '',
      visitCount: '',
      storeCode: '',
      selectedkCity: '',
      pickStore: '',
      outletCat: [],
      page: 1,
      showStoreSelector: false,
      totalDataCount: 0,
      queryStates: window.location.href.split('/').slice(-1)[0],
      selected: '-datetime_last_change',
      options: [
        { item: '-datetime_last_change', name: 'صعودی' },
        { item: 'datetime_last_change', name: 'نزولی' },
      ],
      rangeDate: [],
    };
  },
  async mounted() {
    await this.getType();
    this.getDataPackage();
    this.getCity();
    this.getPromoterLists();
    this.getProvince();
    this.getOutletCat();
    this.$router.afterEach(this.handleUrlChange);
  },
  computed: {
    selectedPromoterId() {
      return this.pickPromoter.id;
    },
    selectedCityId() {
      return this.pickCity.id;
    },
    selectedProvinceId() {
      return this.pickProvince.id;
    },
    showContnetFunc() {
      return this.dataPackage === 0;
    },
    showDataFunc() {
      if (this.dataPackage.length !== undefined) {
        return this.dataPackage.length === 0;
      }
      return false;
    },
  },
  methods: {
    async handleUrlChange(to, from) {
      'sss', to.params.id, from.params.id;
      this.queryStates = to.params.id;

      await this.getType();
      this.getDataPackage();
      this.getCity();
      this.getPromoterLists();
      this.getProvince();
      this.getOutletCat();
    },
    removeFilter() {
      this.pickCity = '';
      this.storeCode = '';
      this.pickProvince = '';
      this.selectedkCity = '';
      this.visitCount = '';
      this.getDataPackage();
      this.getCity();
    },
    getCityOnChange() {
      this.selectedkCity = this.pickProvince;
      this.getCity();
    },
    async getOutletCat() {
      const res = await this.$ApiServiceLayer.get(
        this.$PATH.RELATIVE_PATH.GET.OUTLET_CAT + '?p=' + this.$STORE.state.userConfig.setProjectId,
        this.$PATH.SERVICE_NAME.AUTH
      );
      if (res.status === 200) {
        this.outletCat = res.data;
      }
    },
    async getType() {
      const res = await this.$ApiServiceLayer.get(
        this.$PATH.RELATIVE_PATH.GET.MENU_EDIT +
          '/' +
          this.queryStates +
          '/' +
          '?p=' +
          this.$STORE.state.userConfig.setProjectId,
        this.$PATH.SERVICE_NAME.AUTH
      );
      if (res.status === 200) {
        this.type = res.data;
      }
    },
    async getDataPackage(limit = 20, offset = 0) {
      const res = await this.$ApiServiceLayer.get(
        this.$PATH.RELATIVE_PATH.GET.GET_OUTLET_LIST +
          '?city=' +
          this.pickCity +
          '&city__province=' +
          this.pickProvince +
          '&visit_count=' +
          this.visitCount +
          '&code=' +
          this.storeCode +
          '&limit=' +
          limit +
          '&offset=' +
          offset +
          '&category=' +
          this.type.frontend_api_queryparams +
          '&ordering=' +
          this.selected +
          '&p=' +
          this.$STORE.state.userConfig.setProjectId,
        this.$PATH.SERVICE_NAME.AUTH
      );
      if (res.status === 200) {
        this.dataPackage = res.data.results;
        'sd:', this.dataPackage;
        this.totalDataCount = res.data.count;
      }
    },
    async myCallback() {
      await this.getDataPackage(20, 20 * (this.page - 1));
    },
    detail(id) {
      this.$router.push('/storemng/detail/' + id);
    },
    async getProvince() {
      const res = await this.$ApiServiceLayer.get(
        this.$PATH.RELATIVE_PATH.GET.GET_PROVINCE_LIST +
          '?p=' +
          this.$STORE.state.userConfig.setProjectId,
        this.$PATH.SERVICE_NAME.AUTH
      );
      if (res.status === 200) {
        this.provinceLists = res.data;
      }
    },
    async getCity() {
      const res = await this.$ApiServiceLayer.get(
        this.$PATH.RELATIVE_PATH.GET.GET_CITY_LIST +
          '?city__province=' +
          this.selectedkCity +
          '&p=' +
          this.$STORE.state.userConfig.setProjectId,
        this.$PATH.SERVICE_NAME.AUTH
      );
      if (res.status === 200) {
        'city:', res.data;
        this.cityLists = res.data;
      }
    },
    async getPromoterLists() {
      const res = await this.$ApiServiceLayer.get(
        this.$PATH.RELATIVE_PATH.GET.GET_PROMOTER_LIST +
          '?p=' +
          this.$STORE.state.userConfig.setProjectId,
        this.$PATH.SERVICE_NAME.AUTH
      );
      if (res.status === 200) {
        'promoter:', res.data;
        this.promoterLists = res.data;
      }
    },
    warningPage(id) {
      this.$router.push({ name: 'warningPage', params: { id: id } });
    },
  },
  watch: {
    queryStates: {
      handler(value) {
        value;
      },
    },
    immediate: true, // This ensures the watcher is triggered upon creation
  },
};
</script>
<style lang="scss" scoped>
.follow-order {
  padding: 32px 50px;
  .warning {
    display: flex;
    flex-direction: column;
    border: 1px solid var(--amber-50);
    background: var(--amber-50);
    padding: 16px;
    margin-bottom: 32px;
    border-radius: 8px;
    ul {
      margin-bottom: 0 !important;
      padding: 10px 35px;
    }
    li {
      list-style: disc;
    }
    .text {
      color: var(--amber-700);
      font-size: 16px;
      margin-right: 15px;
    }
  }
  .box {
    // border: 1px solid var(--line-strong);
    padding: 24px;
    border-radius: 2px;
    margin-bottom: 16px;
    background: var(--surface);
    border-radius: 8px;
    box-shadow: 0px 4px 4px rgba(214, 214, 214, 0.6);
    .title {
      font-weight: 700;
      font-size: 18px;
    }
    .package-number {
      height: 38px;
      text-indent: 10px;
    }
    .inputs {
      width: 100%;
      height: 38px;
      border: 1px solid var(--line-strong);
      padding: 0 9px;
      border-radius: 2px;
      font-family: 'IRANYekanfa' !important;
      border-radius: 4px;
    }
  }
  .persian-number {
    font-family: 'IRANYekanfa' !important;
  }
  .warning-box {
    border-radius: 4px;
    padding: 4px 10px;
    font-family: 'IRANYekanfa' !important;
    color: var(--surface);
    cursor: pointer;
  }
  .form-select {
    width: 100%;
    border: 1px solid var(--line-strong);
    height: 38px;
    padding: 0 9px;
    border-radius: 2px;
    color: var(--text-3);
    border-radius: 4px;
  }
  .accept {
    padding: 0 20px;
    height: 38px;
    background: var(--teal-700);
    border-radius: 2px;
    color: var(--surface);
    border: none !important;
    margin-left: 10px;
    border-radius: 4px;
  }
  .remove-filtes {
    padding: 0 20px;
    border: 1px solid var(--teal-700);
    border-radius: 2px;
    color: var(--teal-700);
    height: 38px;
    background: var(--surface);
    border-radius: 4px;
  }
  .ordering-title {
    min-width: 180px;
  }
  .ordering {
    max-width: 100px;
  }
  .show-date {
    border: none;
    text-indent: 55px;
    background: var(--surface);
  }
  .search-input {
    text-indent: 10px;
    height: 40px;
    border: 1px solid var(--line-strong);
    border-radius: 2px;
    font-family: 'IRANYekanfa' !important;
    border-radius: 4px;
  }
  .eye-icon {
    width: 32px;
    cursor: pointer;
  }
}
</style>
